import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GeaMesDatepickerModule, GeaMesDatepickerService, DatePickObj } from '@gea-mes/datepicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { debounceTime } from 'rxjs/operators';

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: 'app-date-selection',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    GeaMesDatepickerModule
  ],
  templateUrl: './date-selection.component.html'
})
export class DateSelectionComponent implements OnInit {

  @Output() dateChange = new EventEmitter<any>();
  private isUpdatingFromPicker = false;
  fg_hdr: FormGroup;
  fromDateString: string;
  toDateString: string;
  currentShift: string = 'True';

  constructor(
    private fb: FormBuilder,
    private datePickerSvc: GeaMesDatepickerService
  ) { }

  ngOnInit(): void {
    const today = dayjs();

    // initialize values (prevents blank fields)
    this.fromDateString = today.format('YYYY-MM-DD');
    this.toDateString = today.format('YYYY-MM-DD');

    this.fg_hdr = this.fb.group({
      f_startDate: [today.format('MM/DD/YYYY'), Validators.required],
      f_endDate: [today.format('MM/DD/YYYY'), Validators.required]
    });

    this.fg_hdr.valueChanges
      .pipe(debounceTime(400))
      .subscribe(val => {

        if (this.isUpdatingFromPicker) return;

        // require full length MM/DD/YYYY
        if (!val.f_startDate || val.f_startDate.length !== 10) return;
        if (!val.f_endDate || val.f_endDate.length !== 10) return;

        const start = dayjs(val.f_startDate, 'MM/DD/YYYY', true);
        const end = dayjs(val.f_endDate, 'MM/DD/YYYY', true);

        // strict validation
        if (!start.isValid() || !end.isValid()) return;

        this.fromDateString = start.format('YYYY-MM-DD');
        this.toDateString = end.format('YYYY-MM-DD');
        this.currentShift = 'False';

        const newObj: DatePickObj = {
          start: start,
          end: end.add(1, 'day'),
          label:
            start.format('MM/DD/YYYY') + ' - ' +
            end.format('MM/DD/YYYY'),
          currentShift: false
        };

        this.datePickerSvc.updateDatePickObjGroup(newObj, -1);

        this.emitChange();
      });
  }

  onDateSelection(e: any) {
    let start = dayjs(e.start).startOf('day');
    let end = dayjs(e.end).startOf('day');

    if (e.currentShift) {
      this.currentShift = 'True';
    } else {
      this.currentShift = 'False';
    }

    this.fromDateString = start.format('YYYY-MM-DD');
    this.toDateString = end.format('YYYY-MM-DD');

    this.isUpdatingFromPicker = true;

    this.fg_hdr.patchValue({
      f_startDate: start.format('MM/DD/YYYY'),
      f_endDate: end.format('MM/DD/YYYY')
    }, { emitEvent: false });

    this.isUpdatingFromPicker = false;

    this.emitChange();
  }



  emitChange() {
    this.dateChange.emit({
      fromDate: this.fromDateString,
      toDate: this.toDateString,
      currentShift: this.currentShift
    });
  }
}